<!--
 * @Date: 2020-09-01 17:25:46
 * @Author: MX
 * @LastAuthor: WZ
 * @LastEditTime: 2025-11-10 16:30:41
 * @Description: 控制台
-->
<template>
  <div class="control main-wrap">
    <div class="control-wrap">
      <div class="main-left">
        <div class="main-left-header">
          <span class="line"></span>
          {{ $lang('控制台') }}
        </div>
        <div class="main-left-aside">
          <div
            class="main-left-aside-item"
            v-for="(item, index) in newAsideList"
            :key="index"
            :class="{ active: item.index === $route.path }"
            :id="driverElementList[index]"
            @click="tabTip(index)"
          >
            <router-link :to="item.index">
              <span >{{ $lang(item.label) }}</span>
            </router-link>
          </div>
        </div>
      </div>
      <div class="main-right">
        <div class="main-right-content">

          <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
            <!--这里是会被缓存的组件-->
          </keep-alive>
          <router-view v-if="!$route.meta.keepAlive"></router-view>
          <!-- <PersonalCenter v-if="tabActive === 0" />
          <Authentication v-if="tabActive === 1"/>
          <Application v-if="tabActive === 2"/>
          <div class="content-item" v-if="tabActive === 3">
            <SmsTemplateManage />
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { RULES } from '@/constants/rules'
import { RESPONSE_SUCCESS } from '@/constants'
import { mapGetters, mapActions } from 'vuex'
// import SmsTemplateManage from './SmsTemplateManage'
// import '@/assets/js/TCaptcha'
// import Application from './components/application.vue'
// import Authentication from './components/authentication.vue'
// import PersonalCenter from './components/personalCenter.vue'
export default {
  name: 'Control',
  props: {},
  components: {
    // SmsTemplateManage,
    // Application,
    // Authentication,
    // PersonalCenter,
  },
  data() {
    return {
      activeName:'first',
      sandboxActive: 'first',
      tabActive: 0,
      authLevel: null, //已认证等级
      editDisable:false,
      controlFormDisable: false,
      auditStatus: 1, // 开放平台三期-审核状态
      failReason: '', // 开放平台三期-失败原因
      firstPast: false, // 用户第一步走完，改为true
      allowApply: false, //是否允许开发者申请api  ： auditStatus 状态值为 (0,"已提交"),(1,"未认证"),(2,"已认证"),(3,"禁用");
      companyEdit: false, // 决定用户企业信息是修改还是提交
      asideList: [
        {
          label: '开发者认证',
          level: 0,
        },
        {
          label: '企业认证',
          level: 1,
        },
        {
          label: '沙箱管理',
          level: 2,
        },
        {
          label: '接口管理',
          level: 3,
        },
        {
          label: '短信模板管理',
          level: 4,
        },
        {
          label: '应用管理',
          level: 5
        },
        {
          label: '认证管理',
          level: 6
        },
        {
          label: '个人中心',
          level: 7,
        }
      ],
      newAsideList: [
        {
          label: '个人中心',
          level: 0,
          index: '/control/personalCenter'
        },
        {
          label: '认证管理',
          level: 1,
          index: '/control/authentication'
        },
        {
          label: '应用管理',
          level: 2,
          index: '/control/application'
        },
        // {
        //   label: '短信管理',
        //   level: 3,
        //   index: '/control/smsTemplateManage'
        // },
      ],
      driverElementList:{ 0: 'first', 1: 'second', 2: 'third', 3: 'fouth' },
      controlForm: {
        userName: '', //用户名
        userPhone: '', //手机号
        userEmail: '', //邮箱
        enterpriseName: '', //企业全称
        enterpriseType: '', //企业类型
        userProvinceId: '',
        userProvinceName: '',
        userCityId: '',
        userCityName: '',
        userAreaId: '',
        userAreaName: '',
        userDetailedAddress: '', //详细地址
        captcha: '', //验证码
        receiveAddress: {},
      },
      // 开放平台三期-需要传给企业认证子组件的表单信息-start
      companyAuthFormSend: {
        socialCreditCode: '', //社会信用代码
        businessLicensePath: '', //企业工商执照影印件
        corporationName: '', //法人姓名
        corporationCardId: '', //身份证
        corporationProvinceId: '', //省
        corporationProvinceName: '',
        corporationCityId: '', //市
        corporationCityName: '',
        corporationAreaId: '', //区
        corporationAreaName: '',
        corporationDetailedAddress: '', //详细地址
        corporationPhotoPath: '', //身份证照片
        receiveAddress: {},
      },
      // 开放平台三期-需要传给企业认证子组件的表单信息-end
      loginLoading: false,
      remember: false,
      rules: {
        enterpriseName: [
          {
            required: true,
            message: '请输入合法的公司名称',
            trigger: ['blur', 'change'],
          },
          {
            required: true,
            min: 4,
            max: 50,
            message: '请输入合法的公司名称(4~50字符)',
            trigger: ['blur', 'change'],
          },
          RULES.noBlankSpace
        ],
        enterpriseType: [
          {
            required: true,
            message: '请选择客户类型',
            trigger: ['blur', 'change'],
          },
        ],
        userName: [
          {
            required: true,
            message: '请输入姓名',
            trigger: ['blur', 'change'],
          },
          RULES.noBlankSpace
        ],
        userEmail: [
          {
            required: true,
            message: '请输入正确的邮箱账号',
            trigger: ['blur', 'change'],
          },
          RULES.email
        ],
        userDetailedAddress:[
          { required: true, message: '请输入详细地址', trigger: ['blur', 'change']  },
          RULES.noBlankSpace
        ],
        receiveAddress: [
          {
            required: true,
            validator: this.receiveAddress,
            trigger: ['blur', 'change'],
          },
        ],
        userPhone: [RULES.phone],
        // userPhone: [RULES.phone, RULES.checkPhone],
        captcha: [RULES.phoneCode, RULES.noBlankSpace],
      },
      getFirsting: true,
      isSendCode: false,
      time: 60,
      codeTimer: null,
      addressOptions: [], //层级下拉
      cityList: [],
      areaList: [],
      casprops: {
        value: 'id',
        label: 'nativeName',
        lazy: true,
        lazyLoad: (node, resolve) => {
          const { level, value } = node
          let params
          let type
          level === 1 ? (type = 3) : (type = 4)
          params = {
            parentId: value,
            type: type,
          }
          const formData = new FormData()
          Object.keys(params).forEach((key) => {
            formData.append(key, params[key])
          })
          if (!this.getFirsting) {
            this.$API.areaList(formData).then((res) => {
              if (res.code === RESPONSE_SUCCESS) {
                let resList = res.data
                if (level === 1) {
                  this.cityList = resList
                } else if (level === 2) {
                  this.areaList = resList
                }
                resList = resList.map((item) =>
                  Object.assign({}, item, {
                    leaf: level >= 2,
                  })
                )
                resolve(resList)
              } else {
                this.$message.error(res.msg)
              }
            })
          }
        },
      },
      enterpriseTypeOptions: [
        {
          value: '1',
          label: '平台',
        },
        {
          value: '2',
          label: '软件供应商',
        },
        {
          value: '3',
          label: '商家自研系统',
        },
        {
          value: '4',
          label: '其他',
        },
      ],

      receiverAddressData: {
        //公司地址
        formProps: {
          provinceIdProp: 'userProvinceId',
          provinceNameProp: 'userProvinceName',
          cityIdProp: 'userCityId',
          cityNameProp: 'userCityName',
          areaIdProp: 'userAreaId',
          areaNameProp: 'userAreaName',
        },
        defaultData: {},
      },
      captcha:"",//腾讯验证码
      guideOptions: [] //引导配置
    }
  },
  computed: {
    ...mapGetters(['user', 'token', 'uuid'])
  },
  watch:{
    // 'auditStatus':{
    //   handler (newVal) {
    //     this.controlFormDisable =  newVal === 2
    //     this.editDisable = !newVal && newVal !== 0 ? false : true
    //     this.firstPast = !newVal && newVal !== 0
    //   },
    //   deep: true,
    //   immediate: true,
    // },
    // 'authLevel':{
    //   handler (newVal) {
    //     // 判断企业认证是否是修改状态 , newVal等于1 说明是在企业认证页面，this.auditStatus>=1 说明用户之前提交过企业认证信息，这时候才能是true
    //     this.companyEdit =  newVal >= 1 && this.auditStatus >= 1
    //   },
    //   deep: true,
    //   immediate: true,
    // },
    'isGuide': {
      handler(v) {
        if (v) {
          this.guideInit()
        }
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    if (this.token) {
      //判断是否认证
      this.isAuth()
    } else {
      this.$router.push({ path: '/login' })
    }
    // this.initTencentCaptcha()
  },
  filters: {
    statusFilter(val){
      const myMap = new Map([
        [0,'审核中'],
        [1,'审核中'],
        [2,'认证通过'],
        [3,'认证不通过']
      ])
      return  myMap.get(val) ? myMap.get(val) : '未申请'
    }
  },
  mounted() {
    if (this.$route.query.id) {
      this.tabActive = Number(this.$route.query.id)
    }
  },
  methods: {
    ...mapActions(['SET_UUID']),
    deleteTest() {
      document.getElementById('testDiv').remove()
    },
    /**
     * @description 新手导航
     */
    guideInit() {
      this.guideOptions = [
        { element: 'first', title: '个人主页', content: '个人中心可查看接口签名所需要的apiAccount和privateKey。' },
        { element: 'second', title: '认证管理', content: '通过认证管理来进行身份认证及开发者信息认证。' },
        { element: 'third', title: '应用管理', content: '进入应用管理来完成API接口添加、自主测试、上线申请。' },
        { element: 'fouth', title: '短信管理', content: '进入短信管理来维护短信模板。' }
      ]
    },
    sendCodeBefore(){
      if (!this.controlForm.userPhone) {
        return this.$message.warning(this.$lang('请输入手机号'))
      }
      this.captcha.show()
    },
    // 初始化tx验证码
    initTencentCaptcha() {
      // 生成实例对象
      this.captcha = window.CaptchaSDK && window.CaptchaSDK.init(this.tencentCaptchaCallback, { forceLang: 'zh-cn' });
    },
    // 验证码回调
    async tencentCaptchaCallback(res) {
      console.log('腾讯验证码回调：callback', res);
      // 验证成功，返回对象
      if (res.ret === 0) {
        // 定义参数：票据 随机字符串
        const customParams = {
          ticket: res.ticket,
          randstr: res.randstr
        }
        // 调用登陆
        this.sendCode(customParams)

        return res
      }
      // 验证不成功
      return null
    },
    /**
     * @description 左侧点击
     */
    tabTip(num) {
      // if (this.auditStatus !== 2 && num > 1) {
      //   //企业信息认证
      //   return this.$message.warning('请先完成企业信息认证，若已填写信息请耐心等待审核结果')
      // }
      if(num === 0) {
        const {userProvinceId, userProvinceName, userCityId, userCityName, userAreaId, userAreaName} = this.controlForm.receiveAddress
        // 回显公司省市区，用户一进来停留在企业认证页面，开发者页面的地址回显有问题，没有触发watch函数，这里手动保存触发(其实之前dataEcho函数已经保存了)
        this.receiverAddressData.defaultData = {
          userProvinceId,
          userProvinceName,
          userCityId,
          userCityName,
          userAreaId,
          userAreaName,
        }
      }
      this.tabActive = num
    },
    /**
     * @description 发送验证码
     */
    sendCode({ticket,randstr}) {
      let httpParams = {
        phone: this.controlForm.userPhone,
        type: 'dev_cer',
        ticket,
        randstr
      }
      this.$API.sendMessage(httpParams).then((res) => {
        if (res.code === RESPONSE_SUCCESS) {
          this.isSendCode = true
          clearInterval(this.codeTimer)
          this.codeTimer = setInterval(() => {
            this.time--
            if (this.time === 0) {
              this.isSendCode = false
              this.time = 60
            }
          }, 1000)
          this.$message.success(this.$lang(this.$lang('获取手机验证码成功')))
        } else {
          this.$message.error(this.$lang(res.msg))
        }
      })
    },
    /**
     * @description 修改时要点击修改，输入框才能编辑
     */
    openEdit() {
      this.editDisable = false;
    },
    /**
     * @description 修改时要点击返回，重新请求数据，按钮输入框不可编辑
     */
    backStep() {
      this.editDisable = true;
      // 恢复表单默认值， 再去请求
      this.$refs['controlForm'].resetFields();
      this.isAuth('dev')
    },
    /**
     * @description 下一步
     */
    nextStep() {
      this.$refs.controlForm.validate((valid) => {
        if (valid) {
          let newParams = {
            userPhone: this.controlForm.userPhone,
            userName: this.controlForm.userName,
            userEmail: this.controlForm.userEmail,
            enterpriseName: this.controlForm.enterpriseName,
            enterpriseType: this.controlForm.enterpriseType,
            userProvinceId: this.controlForm.receiveAddress.userProvinceId,
            userProvinceName: this.controlForm.receiveAddress.userProvinceName,
            userCityId: this.controlForm.receiveAddress.userCityId,
            userCityName: this.controlForm.receiveAddress.userCityName,
            userAreaId: this.controlForm.receiveAddress.userAreaId,
            userAreaName: this.controlForm.receiveAddress.userAreaName,
            userDetailedAddress: this.controlForm.userDetailedAddress,
            captcha: this.controlForm.captcha,
            userId: this.user.id
          }
          if(this.auditStatus !== 2) {
            this.$API.devCerCommit(newParams).then((res) => {
              if (res.code === RESPONSE_SUCCESS) {
                this.tabActive = 1
                this.authLevel = 1
                this.$message.success('开发者认证成功')
                clearInterval(this.codeTimer)
                this.isSendCode = false
                this.time = 60
                // 恢复表单默认值， 再去请求
                this.$refs['controlForm'].resetFields();
                this.isAuth()
              } else {
                // this.isAuth() 如果失败了，这里停留在原页面，不应该再去请求认证信息
                this.$message.error(res.msg)
              }
            })
          } else {
            let params = {
              userName: this.controlForm.userName,
              userPhone: this.controlForm.userPhone,
              userEmail: this.controlForm.userEmail,
              phoneCode: this.controlForm.captcha,
              userId: this.user.id
            }
            this.$API.updateCerCommit(params).then((res) => {
              if (res.code === RESPONSE_SUCCESS && res.data) {
                this.tabActive = 1
                this.authLevel = 1
                this.$message.success('开发者信息修改成功')
                clearInterval(this.codeTimer)
                this.isSendCode = false
                this.time = 60
                // 恢复表单默认值， 再去请求
                this.$refs['controlForm'].resetFields();
                this.isAuth()
              } else {
                // this.isAuth() 如果失败了，这里停留在原页面，不应该再去请求认证信息
                this.$message.error(res.msg)
              }
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    /**
     * @description 获取省市区
     */
    getAreaList() {
      this.getFirsting = true
      let params = {
        parentId: '1',
        type: '2',
      }
      const formData = new FormData()
      Object.keys(params).forEach((key) => {
        formData.append(key, params[key])
      })
      this.$API.areaList(formData).then((res) => {
        if (res.code === RESPONSE_SUCCESS) {
          this.addressOptions = res.data
          this.getFirsting = false
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    /**
     * @description 企业认证提交信息，还是停留原页面
     */
    companyAuthSuccess() {
      this.isAuth()
    },
    /**
     * @description 企业认证被激活，就要实时去拿
     */
    pageActive() {
      this.$API.getCertificationInfo().then((res) => {
        if (res.code === RESPONSE_SUCCESS) {
          if (res.data.userCompany) {
            //已进行企业认证，这里要把获取的信息传给子组件，这里我们只关心企业信息有没有更新
            // 数据回显
            this.dataEcho(2, res.data.userCompany)
          }
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    /**
     * @description 判断是否认证
     */
    isAuth() {
      this.$API.getCertificationInfo().then((res) => {
        if (res.code === RESPONSE_SUCCESS) {
          this.auditStatus = res.data.auditStatus
          // 这里需要判断是否认证通过，认证通过，并且uuid为空，即需要保存
          if(res.data.auditStatus == 2 && this.uuid.length == 0) {
            this.SET_UUID(res.data.uuid)
          }
          // if(val === 'edit'){
          //   this.auditStatus = ''
          //   this.auditStatus = !res.data.auditStatus && res.data.auditStatus !== 0 ? '' : res.data.auditStatus
          //   if (res.data.userCompany) {
          //     //已进行企业认证，这里要把获取的信息传给子组件
          //     this.authLevel = null
          //     this.authLevel = res.data.auditStatus === 2 ? 2 : 1
          //     // 数据回显
          //   }
          // }else{
          //   this.authLevel = 0
          //   if (res.data.userDev) {
          //     //已进行开发者认证
          //     this.authLevel = 1
          //     // 数据回显
          //     this.dataEcho(1, res.data.userDev)
          //   }
          //   if (res.data.userCompany) {
          //     //已进行企业认证，这里要把获取的信息传给子组件，认证通过才能到达企业认证页面
          //     this.authLevel = res.data.auditStatus === 2 ? 2 : 1
          //     // 数据回显
          //     this.dataEcho(2, res.data.userCompany)
          //   }
          //   //  allowApply:false,//是否允许开发者申请api  ： auditStatus 状态值为 (0,"已提交"),(1,"未认证"),(2,"已认证"),(3,"禁用");
          //   if (res.data.auditStatus && res.data.auditStatus == 2) {
          //     //已认证   允许申请api接口
          //     this.allowApply = true
          //   }
          //   this.auditStatus = ''
          //   this.auditStatus = !res.data.auditStatus && res.data.auditStatus !== 0 ? '' : res.data.auditStatus
          //   // 210303 多了沙箱环境这个侧边栏选项，接口管理tabActive的值实际上是3
          //   this.tabActive = this.authLevel === 2? 2 :this.authLevel
          //   if(this.$route.params.updateDevCer) {
          //     this.tabActive = 0
          //     // 提交成功后都会调用isAuth这个方法，因为路由里updateDevCer这个参数一直存在，可能会有修改完企业信息跳到开发者信息的情况，因此，这个参数用一次就要删掉
          //     delete this.$route.params.updateDevCer
          //   }
          //   if(val === 'dev'){
          //     this.tabActive = 0
          //   }
          // }
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    /**
     * @description 数据回显的方法
     */
    dataEcho(type, val){
      if(type === 1) {
        // 数据回显-已进行开发者认证
        const { enterpriseName, userProvinceId, userProvinceName, userCityId, userCityName, userAreaId, userAreaName, enterpriseType, userDetailedAddress, userName, userPhone, userEmail } = val
        this.controlForm.enterpriseName = enterpriseName // 公司名字
        this.controlForm.userProvinceId = userProvinceId // 省份
        this.controlForm.userProvinceName = userProvinceName // 省份
        this.controlForm.userCityId = userCityId
        this.controlForm.userCityName = userCityName // 城市
        this.controlForm.userAreaId = userAreaId
        this.controlForm.userAreaName = userAreaName
        this.controlForm.enterpriseType = String(enterpriseType) // 公司类型
        this.controlForm.userDetailedAddress = userDetailedAddress // 公司详细地址
        this.controlForm.userName = userName // 用户名
        this.controlForm.userEmail = userEmail // 用户邮箱
        this.controlForm.userPhone = userPhone // 用户手机号
        this.controlForm.receiveAddress = {userProvinceId, userProvinceName, userCityId, userCityName, userAreaId, userAreaName}
        // 回显公司省市区
        this.receiverAddressData.defaultData = {
          userProvinceId,
          userProvinceName,
          userCityId,
          userCityName,
          userAreaId,
          userAreaName,
        }
      }
      if(type === 2) {
        // 数据回显-已进行企业认证
        const {socialCreditCode, businessLicensePath, corporationName,   corporationCardId, corporationProvinceId, corporationProvinceName, corporationCityId,corporationCityName, corporationAreaId, corporationAreaName, corporationDetailedAddress, corporationPhotoPath, remark } = val
        this.failReason = remark || '' // 失败的原因，放在返回的企业信息对象里
        this.companyAuthFormSend.socialCreditCode = socialCreditCode
        this.companyAuthFormSend.businessLicensePath = businessLicensePath
        this.companyAuthFormSend.corporationName = corporationName
        this.companyAuthFormSend.corporationCardId = corporationCardId
        this.companyAuthFormSend.corporationProvinceId = corporationProvinceId
        this.companyAuthFormSend.corporationProvinceName = corporationProvinceName
        this.companyAuthFormSend.corporationCityId = corporationCityId
        this.companyAuthFormSend.corporationCityName = corporationCityName
        this.companyAuthFormSend.corporationAreaId = corporationAreaId
        this.companyAuthFormSend.corporationAreaName = corporationAreaName
        this.companyAuthFormSend.corporationDetailedAddress = corporationDetailedAddress
        this.companyAuthFormSend.corporationPhotoPath = corporationPhotoPath
        this.companyAuthFormSend.receiveAddress = {corporationProvinceId, corporationProvinceName, corporationCityId, corporationCityName, corporationAreaId, corporationAreaName}
      }
    },
    receiveAddress(rule, value, callback) {
      //验证地址
      if (this.controlForm.receiveAddress === '') {
        callback(new Error('请选择输入地址'));
        return;
      }
      const {  userProvinceName, userCityName, userAreaName } = this.controlForm.receiveAddress

      if(userProvinceName == "" || userCityName == "" || userAreaName == ""){
        callback(new Error('请选择输入地址'));
      } else {
        callback()
      }
    },
  },
  destroyed() {
    clearInterval(this.codeTimer)
  },
}
</script>

<style lang="scss" scoped>
.control {
  background: #f4f5f7;
  .control-wrap {
    padding: 20px 0;
    height: 100%;
    width: 1200px;
    margin: 0 auto;
    box-sizing: border-box;
    display: flex;
    .main-left {
      width: 240px;
      box-sizing: border-box;
      margin-right: 20px;
      background: #fff;
      border-radius: 10px;
      .main-left-header {
        position: relative;
        height: 71px;
        width: 100%;
        border-bottom: 1px solid $table-border-color;
        color: #2b2d42;
        font-size: 26px;
        font-weight: 900;
        line-height: 26px;
        padding: 22px 0 22px 20px;
        box-sizing: border-box;
        .line {
          width: 4px;
          height: 28px;
          background: $theme-color;
          border-radius: 2px;
          display: inline-block;
          position: absolute;
          left: 0;
          top: 22px;
        }
      }
      .main-left-aside {
        box-sizing: border-box;
        .main-left-aside-item{
          font-size: 14px;
          font-weight: 400;
          color: #61666d;
          line-height: 16px;
          padding-top: 34px;
          padding-left: 32px;
          cursor: pointer;
          &.first {
            margin-top: 47px;
          }
          &.active a {
            color: $theme-color;
            font-weight: 600;
          }
          a {
            color: #61666d;
            text-decoration: none;
          }
        }
      }
    }
    .main-right {
      flex: 1;
      background: #fff;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      border-radius: 10px;
      .main-right-header {
        height: 98px;
        box-sizing: border-box;
        padding: 30px 0 30px 30px;
        display: flex;
        border-bottom: 1px solid $table-border-color;
        .right-header-item {
          flex: 1;
          position: relative;
          .iconfont.iconkongzhitai_wanchengbuzhou {
            position: absolute;
            top: 5px;
            left: 0;
            font-size: 24px;
            color: $theme-color;
          }
          .circle {
            position: absolute;
            top: 5px;
            left: 0;
            width: 24px;
            height: 24px;
            background: $theme-color;
            font-size: 14px;
            text-align: center;
            color: #ffffff;
            border-radius: 50%;
            line-height: 24px;
            &.grayClass {
              background: #dadee3;
            }
          }
          .title {
            position: absolute;
            top: 0px;
            left: 30px;
            font-size: 16px;
            font-weight: 600;
            color: #2b2d42;
            line-height: 16px;
          }
          .subTitle {
            position: absolute;
            top: 20px;
            left: 30px;
            font-size: 12px;
            font-weight: 400;
            color: #a1a3a6;
            line-height: 16px;
            height: 16px;
            width: 72px;
          }
          .iconbuzhouhongsejiantou {
            font-size: 14px;
            position: absolute;
            top: 12px;
            right: 23px;
            color: $theme-color;
            &.grayColor {
              color: #d2d8e0;
            }
          }
        }
      }
      .main-right-content {
        box-sizing: border-box;
        // padding: 30px 30px 15px;
        flex: 1;
        overflow-y: auto;
        .content-item {
          position: relative;
          padding: 20px 30px;
          h3 {
            font-size: 22px;
            color: #2b2d42;
            line-height: 22px;
            margin-bottom: 20px;
            .iconfont {
              color: $theme-color;
              font-size: 24px;
              margin-right: 16px;
              font-weight: normal;
            }
          }
          .audit-status {
            position: absolute;
            right: 0;
            top: -15px;
            font-size: 14px;
            text-align: right;
            .iconfont {
              margin-right: 6px;
              font-size: 14px;
            }
            .iconshenhezhuangtai_weishenqingshibai {
              color: #E60012;
            }
            .iconshenhezhuangtai_shenhezhong {
              color: rgb(45, 124, 255);
            }
            .iconshenhezhuangtai_tongguo {
              color: rgb(34, 206, 136);
            }
            span{
              color: #E60012;
            }
          }
          &.second {
            margin-top: 50px;
          }
          .sandbox-title {
            color: #2b2d42;
          }
        }
      }
    }
    .nextStep {
      width: 450px;
      height: 40px;
      background-color: $theme-color;
      color: #fff;
      font-size: 14px;
      margin-left: 180px;
      margin-top: 8px;
    }
    .back {
      width: 215px;
      height: 40px;
      border: 1px solid #b0b3b6;
      border-radius: 4px;
      color: #61666d;
      font-weight: 400;
      margin-left: 180px;
    }
    .save {
      width: 215px;
      height: 40px;
      background-color: $theme-color;
      border-radius: 4px;
      color: #ffffff;
      margin-left: 20px;
    }
    .captchaItem {
      .sendCode {
        width: 88px;
        height: 40px;
        background-color: $theme-color;
        color: #fff;
        margin-left: 20px;
      }
    }
  }
}
.control::v-deep {

  .el-form-item{
    .el-form-item{
      margin-bottom: 0 !important;

    }
    .el-form-item.nth-2{
      margin-left: 20px;
    }
  }
  .el-form-item__label {
    color: #4c4d57;
  }
  .el-input {
    width: 450px;
  }
  .captchaItem .el-input {
    width: 342px;
  }
  .el-cascader .el-input {
    width: 200px;
  }
  .address .el-input.input {
    width: 230px;
  }
}
</style>
<style lang="scss">
div#driver-popover-item{
  border-radius: 6px;
}
div#driver-page-overlay {
  background-color: #B8B8B8;
}
div#driver-highlighted-element-stage {
  height: 50px !important;
}
</style>
